export const handleDownloadMrc = (blobs: Blob[]) => {
    return new Blob(blobs)
}
